import { formatTime } from "content/Campgain/util"

const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']


const capitalize = (input) => {
  var words = input.split('_');
  var CapitalizedWords = [];
  words.forEach(element => {
    CapitalizedWords.push(element[0].toUpperCase() + element.slice(1, element.length));
  });
  return CapitalizedWords.join(' ');
}

const compare = (a, b, order) => {
  if (a < b) {
    return order ? 1 : -1
  }
  if (a > b) {
    return order ? -1 : 1
  }
  return 0
}

const sortingTableData = (key, _tableData, orderType, isListView) => {
  let tableData = [..._tableData]
  if (tableData.lenght < 2) return tableData;
  let i = 0;
  while (i < tableData.length - 1) {
    let temp = !isListView ? tableData[i] : tableData[i].node;
    let k = i;
    for (let j = k; j < tableData.length; j++) {
      let _tableItem = !isListView ? tableData[j] : tableData[j].node;
      if (orderType == "asc") {
        if (_tableItem[key] < temp[key]) {
          temp = _tableItem;
          k = j;
        }
      } else {
        if (_tableItem[key] > temp[key]) {
          temp = _tableItem;
          k = j;
        }
      }
    }
    if (i != k) {
      let copy = tableData[k];
      tableData[k] = tableData[i];
      tableData[i] = copy;
    }
    i++;
  }
  return tableData
}


export const parseDate = (d) => {
  return getDate(d) + ", " + formatTime(new Date(d))
}

export const getDate = (e) => {
  let date = new Date(e);
  return date.getDate() + " " + months[date.getMonth()] + ", " + date.getFullYear() + " - " + formatTime(new Date(e))
}

const createDateRange = (dateString) => {
  if (dateString) {
    let dateDetails = dateString.split('-');
    if (dateDetails.length !== 2) return
    let startDate = new Date(dateDetails[0], dateDetails[1] - 1).toISOString();
    let endDate = new Date(dateDetails[0], dateDetails[1], 0).toISOString();
    return {
      endAt: endDate,
      startAt: startDate
    }
  } else {
    return {
      endAt: null,
      startAt: null
    }
  }
}

export {
  capitalize,
  sortingTableData,
  compare,
  createDateRange
}